export default (statusName: string): string => {
    switch (statusName) {
        case 'packingInProgress':
            return 'Packing in progress';
        case 'pending':
        case 'created':
        case 'rejected':
            return 'Open';
        default:
            return statusName[0].toUpperCase() + statusName.substring(1);
    }
};



// WEBPACK FOOTER //
// ./src/view/order/OrderStatusTranslator.ts